import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook } from "react-icons/fa";

const mapsQuery = encodeURIComponent("1485 Mary Avenue, Cambridge, ON N3H 4N8");

const details = [
  {
    icon: FaMapMarkerAlt,
    title: "Address",
    body: "1485 Mary Avenue\nCambridge, ON  N3H 4N8",
    href: `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`,
    cta: "Get directions",
  },
  {
    icon: FaPhoneAlt,
    title: "Phone",
    body: "519-580-9576",
    href: "tel:+15195809576",
    cta: "Call us",
  },
  {
    icon: FaEnvelope,
    title: "Email",
    body: "jose@thelittleflock.com",
    href: "mailto:jose@thelittleflock.com",
    cta: "Send an email",
  },
];

const Contact = () => {
  return (
    <section id="contact" className="w-full bg-white py-20 px-4 md:py-28">
      <div className="mx-auto max-w-[1240px]">
        <div className="mx-auto max-w-2xl text-center">
          <p className="section-label">Get in Touch</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-maroon sm:text-4xl">
            Come Worship With Us
          </h2>
          <p className="mt-4 text-ink/70">
            Have a question or need prayer? We'd love to hear from you.
          </p>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          {/* Details */}
          <div className="space-y-5">
            {details.map(({ icon: Icon, title, body, href, cta }) => (
              <a
                key={title}
                href={href}
                target={title === "Address" ? "_blank" : undefined}
                rel={title === "Address" ? "noopener noreferrer" : undefined}
                className="flex items-start gap-4 rounded-2xl border border-sand bg-cream p-5 transition hover:border-terracotta hover:shadow-md"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-maroon text-white">
                  <Icon size={18} />
                </span>
                <div>
                  <h3 className="font-serif text-xl font-bold text-maroon">
                    {title}
                  </h3>
                  <p className="whitespace-pre-line text-ink/80">{body}</p>
                  <span className="mt-1 inline-block text-sm font-semibold text-terracotta">
                    {cta} →
                  </span>
                </div>
              </a>
            ))}

            <a
              href="https://www.facebook.com/littleflockchurchkitchener"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 rounded-2xl border border-sand bg-cream p-5 transition hover:border-terracotta hover:shadow-md"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-maroon text-white">
                <FaFacebook size={18} />
              </span>
              <div>
                <h3 className="font-serif text-xl font-bold text-maroon">
                  Facebook
                </h3>
                <p className="text-ink/80">Follow us for livestreams & updates</p>
                <span className="mt-1 inline-block text-sm font-semibold text-terracotta">
                  Visit our page →
                </span>
              </div>
            </a>
          </div>

          {/* Map */}
          <div className="min-h-[360px] overflow-hidden rounded-2xl shadow-lg">
            <iframe
              title="Map to The Little Flock Tabernacle"
              src={`https://www.google.com/maps?q=${mapsQuery}&output=embed`}
              className="h-full min-h-[360px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
